export default __webpack_public_path__ + "static/media/word.4caa2055.svg";